/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AttachmentFromJSON, AttachmentToJSON, } from './Attachment';
import { BlueprintFromJSON, BlueprintToJSON, } from './Blueprint';
import { SecurityFocusLiteFromJSON, SecurityFocusLiteToJSON, } from './SecurityFocusLite';
import { SpidrImprovementFromJSON, SpidrImprovementToJSON, } from './SpidrImprovement';
import { SpidrStateFromJSON, SpidrStateToJSON, } from './SpidrState';
/**
 * Check if a given object implements the SpidrWithFocus interface.
 */
export function instanceOfSpidrWithFocus(value) {
    let isInstance = true;
    isInstance = isInstance && "securityFocus" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "deliveredAt" in value;
    isInstance = isInstance && "expiryDate" in value;
    isInstance = isInstance && "blueprint" in value;
    isInstance = isInstance && "customerActionItems" in value;
    isInstance = isInstance && "customerRecommendations" in value;
    isInstance = isInstance && "cstActionItems" in value;
    isInstance = isInstance && "attachments" in value;
    isInstance = isInstance && "ticketId" in value;
    isInstance = isInstance && "noCstActionItems" in value;
    isInstance = isInstance && "noCustomerActionItems" in value;
    isInstance = isInstance && "rating" in value;
    isInstance = isInstance && "improvements" in value;
    return isInstance;
}
export function SpidrWithFocusFromJSON(json) {
    return SpidrWithFocusFromJSONTyped(json, false);
}
export function SpidrWithFocusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'securityFocus': SecurityFocusLiteFromJSON(json['securityFocus']),
        'id': json['id'],
        'version': json['version'],
        'state': SpidrStateFromJSON(json['state']),
        'deliveredAt': (json['deliveredAt'] === null ? null : new Date(json['deliveredAt'])),
        'expiryDate': (json['expiryDate'] === null ? null : new Date(json['expiryDate'])),
        'blueprint': BlueprintFromJSON(json['blueprint']),
        'customerActionItems': json['customerActionItems'],
        'customerRecommendations': json['customerRecommendations'],
        'cstActionItems': json['cstActionItems'],
        'attachments': (json['attachments'].map(AttachmentFromJSON)),
        'ticketId': json['ticketId'],
        'noCstActionItems': json['noCstActionItems'],
        'noCustomerActionItems': json['noCustomerActionItems'],
        'rating': json['rating'],
        'improvements': (json['improvements'].map(SpidrImprovementFromJSON)),
        'totalSteps': !exists(json, 'totalSteps') ? undefined : json['totalSteps'],
        'finishedSteps': !exists(json, 'finishedSteps') ? undefined : json['finishedSteps'],
    };
}
export function SpidrWithFocusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'securityFocus': SecurityFocusLiteToJSON(value.securityFocus),
        'id': value.id,
        'version': value.version,
        'state': SpidrStateToJSON(value.state),
        'deliveredAt': (value.deliveredAt === null ? null : value.deliveredAt.toISOString()),
        'expiryDate': (value.expiryDate === null ? null : value.expiryDate.toISOString().substr(0, 10)),
        'blueprint': BlueprintToJSON(value.blueprint),
        'customerActionItems': value.customerActionItems,
        'customerRecommendations': value.customerRecommendations,
        'cstActionItems': value.cstActionItems,
        'attachments': (value.attachments.map(AttachmentToJSON)),
        'ticketId': value.ticketId,
        'noCstActionItems': value.noCstActionItems,
        'noCustomerActionItems': value.noCustomerActionItems,
        'rating': value.rating,
        'improvements': (value.improvements.map(SpidrImprovementToJSON)),
        'totalSteps': value.totalSteps,
        'finishedSteps': value.finishedSteps,
    };
}
